import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';

function AuthLayout(): React.ReactElement {
  return (
    <div className="min-h-screen bg-background flex">
      {/* Left side - Branding/Visual */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-dark relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute inset-0">
          {/* Gradient orbs */}
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/20 rounded-full blur-3xl" />
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-secondary/20 rounded-full blur-3xl" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-accent/10 rounded-full blur-2xl" />
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col justify-center items-center w-full p-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center"
          >
            {/* Logo */}
            <div className="mb-8">
              <h1 className="text-6xl font-bold text-gradient-primary">BOIS</h1>
              <p className="text-foreground-muted text-lg mt-2">
                Business Operations Intelligence System
              </p>
            </div>

            {/* Feature highlights */}
            <div className="mt-12 space-y-6 max-w-md">
              <FeatureItem
                title="Smart Analytics"
                description="Real-time insights to drive your business decisions"
              />
              <FeatureItem
                title="Team Collaboration"
                description="Work together seamlessly across your organization"
              />
              <FeatureItem
                title="Secure & Reliable"
                description="Enterprise-grade security for your data"
              />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Right side - Auth forms */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

interface FeatureItemProps {
  title: string;
  description: string;
}

function FeatureItem({ title, description }: FeatureItemProps): React.ReactElement {
  return (
    <div className="flex items-start gap-4 text-left">
      <div className="w-2 h-2 mt-2 rounded-full bg-primary flex-shrink-0" />
      <div>
        <h3 className="text-foreground font-medium">{title}</h3>
        <p className="text-foreground-subtle text-sm">{description}</p>
      </div>
    </div>
  );
}

export default AuthLayout;
